import styled from '@emotion/styled';
import SrOnlyText from '@shared/components/core/text/SrOnlyText';
import { color } from '@shared/constants/Styles';
import { ICoreButtonProps } from '@shared/models/components/ICoreButtonProps';
import Button from './CoreButton';

// TODO Component refactor: use IconsButton
export interface IDeleteButtonProps extends ICoreButtonProps {
    showLabel?: boolean;
}

function DeleteIconButton({ children, $color = 'simple', $size = 'small', onClick }: IDeleteButtonProps) {
    return (
        <StyledButton $color={$color} $size={$size} startIcon="delete" onClick={onClick}>
            <SrOnlyText>{children}</SrOnlyText>
        </StyledButton>
    );
}

const StyledButton = styled(Button)`
    width: 42px;
    height: 42px;
    gap: 0;
    color: ${color.error};
    border-radius: 50%;
    :hover {
        background-color: ${color.error};
        box-shadow: none;
        color: white;
        svg {
            fill: white;
        }
    }
`;

export default DeleteIconButton;
